import React from "react";
import { Box, Grid, LinearProgress } from "@material-ui/core";
import ExportButtonContainer from "../Export/ExportButtonContainer";
import NoData from "../Consumption/NoData";

const Process = ({ noData, ChartComponent, LegendComponent, isLoading }) => {
  if (isLoading) {
    return (
      <Box marginTop={2}>
        <LinearProgress color="secondary" />
      </Box>
    );
  }

  if (noData) {
    return (
      <>
        <NoData />
        {LegendComponent}
      </>
    );
  }

  return (
    <>
      {ChartComponent}
      {LegendComponent}

      <Grid container spacing={2}>
        <Grid item xs={6}></Grid>
        <Grid item xs={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end" marginTop={1}>
                <ExportButtonContainer currentView="measurement" />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Process;
